import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineScheduleChangeModal のスタイル
 */
export const hotlineScheduleChangeModalStyle = tv({
    slots: {
        base: ['!max-w-[min(416px,100%)]'],
        button: ['sm:max-[200px]'],
        buttonWrap: ['flex flex-col sm:flex-row-reverse justify-center gap-16'],
        checkbox: ['mx-auto'],
        confirmContent: [
            'flex justify-center',
            'p-16',
            'bg-blue-gray-75',
            'rounded-md',
        ],
        confirmContentInner: ['flex flex-col gap-8'],
        contentWrap: ['flex flex-col gap-20 lg:gap-24'],
        fieldWrap: ['w-full', 'mt-16'],
        requiredTag: ['shrink-0', 'ml-8'],
        scheduleContent: ['flex flex-col gap-24'],
        warningPointContent: ['bg-orange-50', 'w-full', 'p-16', 'rounded-md'],
        warningPointList: ['flex flex-col gap-8', 'list-disc', 'pl-[18px]'],
        warningPointListItem: [textStyle({ color: 'base', size: 'sm' })],
        warningPointTitle: [textStyle({ color: 'base', isBold: true, size: 'sm' })],
        warningPointWrap: ['flex flex-col item-center gap-8'],
    },
});
